import React, { useState, useCallback } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { api, extractErrorMessage } from "../../../../util/api";
import { snakifyKeys } from "../../../../util/helpers";
import { PhoneResponseForm } from "./PhoneResponseForm";

export const AddPhoneResponseModal = ({ onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = useCallback(
    async (params) => {
      setError(null);
      try {
        const res = await api.post("/admin/phone_responses", snakifyKeys({ phone_response: params }));

        if (onAdd) {
          onAdd(res.data?.meta?.message, res.data?.meta?.error_details);
        }

        setOpen(false);
      } catch (err) {
        setError(extractErrorMessage(err));
      }
    },
    [onAdd]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add New Phone Response
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Phone Response</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{}}>
            {(props) => <PhoneResponseForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
